import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '@/lib/route-guards';
import { useSetViewShim } from '@/lib/use-set-view';
import { CapiForwardingView } from '@/screens/capi-forwarding';

export const Route = createFileRoute('/backend/capi-forwarding')({
  // Route-data exemption: realtime. `conversions.health` polls.
  beforeLoad: requireSession,
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  return <CapiForwardingView setView={setView} />;
}
